import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { routesState } from "state/ecoState";
import { EcoRoute } from "types";

/**
 * 
 * Returns current active EcoRoute 
 * 
 * FIXME does not support nested routes
 * 
 */
export function useActiveEcoRoute() {

    const location = useLocation() ;

    // all routes
    let routes =  useRecoilValue<EcoRoute[]>(routesState) ;

    // route matching current location is the active one
    const active = (routes![0]!).children!.filter((route:EcoRoute) => location.pathname === '/' + route.path! ) ;

    return active.length ? active[0] as EcoRoute : routes[0] ;

}

export default useActiveEcoRoute ;
